export enum CommonApi {
  AlgoliaToken = '/api/v1.0/algolia/userkey',
  UserInfo = '/api/v2/admin/User/getUserDetails',
  CompanyData = '/WebApi/GetCompanyData',
  SASToken = '/webapi/GetSasToken',
  CompanyModules = '/WebApi/GetCompanyModules',
  SlackChannelMessages = '/slack/channel-msg'
}
